module.exports = __webpack_public_path__ + "static/media/timetable.7cf85067.svg";